import React, { useEffect, useState } from 'react';
import { store } from '../../../app/store';
import { postAPI, postAPIForm, getURL } from '../../../app/api';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import './tooltip.css';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';
import Excel from '../../../components/Excel/Excel';
import { DownloadOutlined } from '@ant-design/icons';

export default function List({ PopupID = "", setIsEdit, setEditId }) {
    const store_data = JSON.parse(store());
    const [Coupons, setCoupons] = useState([]);

    // Permission states
    const [canView, setCanView] = useState(false);
    const [canCreate, setCanCreate] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [canDelete, setCanDelete] = useState(false);
    const [canToggleStatus, setCanToggleStatus] = useState(false);
    const [canExport, setCanExport] = useState(false);

    const fetchCoupons = async () => {
        const filter = { org_id: store_data?.org_id }
        const response = await postAPI("/coupons/list", filter);
        if (response?.status == 1) {
            setCoupons(response?.data);
        } else {
            setCoupons([]);
        }
        console.log(response)
    }

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanView(true);
                setCanCreate(true);
                setCanEdit(true);
                setCanDelete(true);
                setCanToggleStatus(true);
                fetchCoupons();
            } else {
                const viewAllowed = await hasPermission("SETTINGS", "Coupons", "VIEW");
                const createAllowed = await hasPermission("SETTINGS", "Coupons", "CREATE");
                const editAllowed = await hasPermission("SETTINGS", "Coupons", "EDIT");
                const deleteAllowed = await hasPermission("SETTINGS", "Coupons", "DELETE");
                const toggleAllowed = await hasPermission("SETTINGS", "Coupons", "TOGGLESTATUS");

                setCanView(viewAllowed);
                setCanCreate(createAllowed);
                setCanEdit(editAllowed);
                setCanDelete(deleteAllowed);
                setCanToggleStatus(toggleAllowed);

                if (viewAllowed) {
                    fetchCoupons();
                }
            }
        };
        checkPermissions();
    }, [])

    const handleChangeStatus = async (id, status) => {
        if (!canToggleStatus) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        const filter = { org_id: store_data?.org_id, id: id, status: status }
        const response = await postAPI("/coupons/toggle-status", filter);
        if (response?.status == 1) {
            toast.success('Status Changed Successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    const handleRemove = async id => {
        if (!canDelete) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        const filter = { org_id: store_data?.org_id, id: id }
        const response = await postAPI("/coupons/remove", filter);
        if (response?.status == 1) {
            toast.success('Coupon Removed Successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    return (
        <>
            <ToastContainer />
            <table class="table card-table">
                <thead>
                    <tr>
                        <th>Exam</th>
                        <th>Coupon Code</th>
                        <th>Discount Type</th>
                        <th>Discount Value</th>
                        <th style={{ width: '100px' }}>Status</th>
                        <th style={{ width: '160px' }}>Actions</th>
                    </tr>
                </thead>
                <tbody class="table-border-bottom-0">
                    {
                        !canView ? (
                            <tr>
                                <td colSpan="6" className="text-center text-danger py-4">
                                    You do not have permission to view this page.
                                </td>
                            </tr>
                        ) : Coupons && Coupons?.length > 0 ?
                            Coupons?.map((val, index) => (
                                <tr key={index + 1}>
                                    <td>{val?.exam_title}</td>
                                    <td>{val?.coupon_code}</td>
                                    <td>{val?.discount_type}</td>
                                    <td>{val?.discount_value}</td>
                                    <td>
                                        <span className="tooltip">
                                            <span className={`badge ${val?.status === 1 ? 'bg-label-success' : 'bg-label-secondary'} me-1 cursor-pointer`} onClick={() => handleChangeStatus(val?.id, !val?.status)}>{val?.status === 1 ? 'Active' : 'Inactive'}</span>
                                            <span className="tooltiptext">Change Status</span>
                                        </span>
                                    </td>
                                    <td>
                                        <span className="tooltip">
                                            <span className="badge bg-label-primary me-1" data-bs-toggle="modal" data-bs-target={`#${PopupID}`} onClick={() => { setIsEdit(true); setEditId(val?.id); }}><i className="fa fa-pen"></i></span>
                                            <span className="tooltiptext">Edit Coupon</span>
                                        </span>
                                        <span className="tooltip">
                                            <span className="badge bg-label-danger me-1 cursor-pointer"
                                                onClick={() => {
                                                    if (window.confirm("Are you sure? This action will permanently remove this data!")) {
                                                        handleRemove(val?.id);
                                                    } else {
                                                        console.log("Remove cancelled.");
                                                    }
                                                }}
                                            ><i className="fa fa-trash"></i></span>
                                            <span className="tooltiptext">Delete Coupon</span>
                                        </span>
                                    </td>
                                </tr>
                            ))
                            : ""
                    }
                </tbody>
            </table>
        </>
    )
}
